import React, { useEffect, useRef } from 'react'
import iconEmpresa from '../../../../assets/images/iconos/iconEmpresa.png'
import iconRuta from '../../../../assets/images/iconos/iconRuta.png'
import iconUnidad from '../../../../assets/images/iconos/iconUnidad.png'
import { useCentroMonitoreo } from '../../../../hooks/monitoreo/useCentroMonitoreo'

const ContenedorIndicadoresOperacion = ({codEmpresa = 0}) => {
  const intervalRef = useRef()
  const hookCentroMonitoreo = useCentroMonitoreo()
  useEffect(() => {
    (async () => {
      await hookCentroMonitoreo.listarIndicadoresDeOperacion()
      await hookCentroMonitoreo.listarAlertasTotalizado(codEmpresa)
      intervalRef.current = setInterval(async () => {
        await hookCentroMonitoreo.listarIndicadoresDeOperacion()
        await hookCentroMonitoreo.listarAlertasTotalizado(codEmpresa)
      }, 10000);
    })()
    return(() => {
      clearInterval(intervalRef.current)
    })
  },[])
  
  return (
    <div className='flex flex-col h-full shadow-xl shadow-white overflow-hidden'>
      <div className='bg-[#017eff] font-bold flex items-center justify-center h-[50px]'>INDICADORES DE OPERACIÓN</div>
      <div className='flex flex-col items-center justify-center px-4 py-5 gap-5'>
        <span className='w-full'>OPERACIÓN HOY:</span>
        <div>
          <table className='table'>
            <thead>
              <tr>
                <th></th>
                <th>TOTAL</th>
                <th>OPERATIVA</th>
                <th>% OPERATIVA</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>EMPRESAS</th>
                <td className='text-center'>{hookCentroMonitoreo.operatividadActual.totalEmpresas}</td>
                <td className='text-center'>{hookCentroMonitoreo.operatividadActual.totalEmpresasOperativas}</td>
                <td className='text-right'>{hookCentroMonitoreo.operatividadActual.porcentajeEmpresasOperativas} %</td>
              </tr>
              <tr>
                <th>RUTAS</th>
                <td className='text-center'>{hookCentroMonitoreo.operatividadActual.totalRutas}</td>
                <td className='text-center'>{hookCentroMonitoreo.operatividadActual.totalRutasOperativas}</td>
                <td className='text-right'>{hookCentroMonitoreo.operatividadActual.porcentajeTotalRutasOperativas} %</td>
              </tr>
              <tr>
                <th>UNIDADES</th>
                <td className='text-center'>{hookCentroMonitoreo.operatividadActual.totalUnidades}</td>
                <td className='text-center'>{hookCentroMonitoreo.operatividadActual.totalUnidadesOperativas}</td>
                <td className='text-right'>{hookCentroMonitoreo.operatividadActual.porcentajeTotalUnidadesOperativas} %</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* <div className='grid grid-cols-[auto_1fr_1fr_1fr] w-full gap-x-4 gap-y-2 text-xs'>
          <div></div>
          <div className='bg-[#5392f6] text-center font-bold'>TOTAL</div>
          <div className='bg-[#5392f6] text-center font-bold'>OP</div>
          <div className='bg-[#5392f6] text-center font-bold'>%OP</div>

          <div className='flex items-center'><img src={iconEmpresa} alt="" className='w-[30px]' />EMPRESAS</div>
          <div className='content-center'>{hookCentroMonitoreo.operatividadActual.totalEmpresas}</div>
          <div className='content-center'>{hookCentroMonitoreo.operatividadActual.totalEmpresasOperativas}</div>
          <div className='content-center'>{hookCentroMonitoreo.operatividadActual.porcentajeEmpresasOperativas} %</div>

          <hr className='col-span-4' />

          <div className='flex items-center'><img src={iconRuta} alt="" className='w-[30px]' />RUTAS</div>
          <div className='content-center'>{hookCentroMonitoreo.operatividadActual.totalRutas}</div>
          <div className='content-center'>{hookCentroMonitoreo.operatividadActual.totalRutasOperativas}</div>
          <div className='content-center'>{hookCentroMonitoreo.operatividadActual.porcentajeTotalRutasOperativas} %</div>

          <hr className='col-span-4' />

          <div className='flex items-center'><img src={iconUnidad} alt="" className='w-[30px]' />UNIDADES</div>
          <div className='content-center'>{hookCentroMonitoreo.operatividadActual.totalUnidades}</div>
          <div className='content-center'>{hookCentroMonitoreo.operatividadActual.totalUnidadesOperativas}</div>
          <div className='content-center'>{hookCentroMonitoreo.operatividadActual.porcentajeTotalUnidadesOperativas} %</div>
        </div> */}
      </div>
      <div className='bg-[#017eff] font-bold flex items-center justify-center h-[50px]'>INCIDENCIAS DE HOY</div>
      <div className='flex flex-col items-center justify-start flex-1 px-4 gap-2 text-xs py-6'>
        {
          hookCentroMonitoreo.alertasTotalizado.length == 0
          ? <div role="status" className="max-w-sm animate-pulse w-full gap-4 flex flex-col">
                <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                <div className="h-4 bg-gray-200 rounded-full dark:bg-gray-700"></div>
            </div>
          : hookCentroMonitoreo.alertasTotalizado.map((data,i) => (
              <div className='flex justify-between w-full h-[25px]' key={i+1}>
                <span className='bg-[#1e1e1e] content-center flex-1 px-2'>{data.nomAlerta.toUpperCase()}</span>
                <div className='bg-[#5c5857] content-center w-[65px] px-2 rounded-sm'>{data.cantidadAlertas}</div>
              </div>
            ))
        }
      </div>
    </div>
  )
}

export default ContenedorIndicadoresOperacion